import React, { useEffect, useState } from 'react';

// Ease-out-cubic count-up. Used in success toasts after bulk operations so the
// "47 Tickets archiviert" headline feels like a tally rather than a static number.
export const CountUpNumber: React.FC<{ target: number; durationMs?: number }> = ({ target, durationMs = 1200 }) => {
  const [value, setValue] = useState(0);
  useEffect(() => {
    if (target === 0) { setValue(0); return; }
    const start = performance.now();
    let raf = 0;
    const tick = (now: number) => {
      const elapsed = now - start;
      const t = Math.min(1, elapsed / durationMs);
      const eased = 1 - Math.pow(1 - t, 3);
      setValue(Math.round(target * eased));
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, durationMs]);
  return <>{value}</>;
};
